<!--
 * @Author: ZhaoG
 * @Date: 2025-04-09 10:57:16
 * @LastEditors: ZhaoG
 * @LastEditTime: 2025-09-15 15:44:20
 * @FilePath: \eva-fe\src\app\sourcingFlow\components\associationRelationWarning.vue
 * @Description: 
-->
<template>
  <div
    class="ccui-multifunctional-table-wrapper  ccui-multifunctional-table-wrapper-detail"
  >
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="股权关联" name="one">
        <div v-if="tabRefresh.one">
          <relationContent
            :relationData="relationData"
            :schemeId="schemeId"
            :packId="packId"
            :relationType="'1'"
          ></relationContent>
        </div>
      </el-tab-pane>
      <!-- <el-tab-pane label="投资关联" name="tow">
        <div v-if="tabRefresh.tow">
          <relationContent
            :relationData="relationData"
            :schemeId="schemeId"
            :packId="packId"
            :relationType="'2'"
          ></relationContent>
        </div>
      </el-tab-pane> -->
      <el-tab-pane label="人员任职关联" name="three">
        <div v-if="tabRefresh.three">
          <relationContent
            :relationData="relationData"
            :schemeId="schemeId"
            :packId="packId"
            :relationType="'3'"
          ></relationContent>
        </div>
      </el-tab-pane>
      <el-tab-pane label="联系方式关联" name="four">
        <div v-if="tabRefresh.four">
          <relationContent
            :relationData="relationData"
            :schemeId="schemeId"
            :packId="packId"
            :relationType="'4'"
          ></relationContent>
        </div>
      </el-tab-pane>
    </el-tabs>
    <el-dialog :visible.sync="dialogShow" width="30%">
      <p v-for="(item, index) in tips" :key="index">{{ item }}</p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogShow = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import relationContent from "./relationContent";
import { getWarningRelationshipList } from "@/app/sourcingFlow/api/expertEvaluation";
export default {
  name: "associationRelationWarning",
  components: {
    relationContent
  },
  props: {
    schemeId: {
      type: String,
      default() {
        return "";
      }
    },
    packId: {
      type: String,
      default() {
        return "";
      }
    }
  },
  data() {
    return {
      activeName: "one",
      relationData: [],
      tabRefresh: {
        one: true,
        tow: false,
        three: false,
        four: false
      },
      dialogShow: false,
      tips: []
    };
  },
  created() {
    // this.init();
  },
  methods: {
    init() {
      this.getList("1");
    },
    handleClick(tab, event) {
      switch (this.activeName) {
        case "one":
          this.switchTab("one");
          break;
        case "tow":
          this.switchTab("tow");
          break;
        case "three":
          this.switchTab("three");
          break;
        case "four":
          this.switchTab("four");
          break;
        default:
      }
    },
    switchTab(tab) {
      for (let [key] of Object.entries(this.tabRefresh)) {
        if (key == tab) {
          if (key == "one") {
            this.relationData = [];
            this.getList("1");
            this.tabRefresh[key] = true;
          } else if (key == "tow") {
            this.relationData = [];
            this.getList("2");
            this.tabRefresh[key] = true;
          } else if (key == "three") {
            this.relationData = [];
            this.getList("3");
            this.tabRefresh[key] = true;
          } else if (key == "four") {
            this.relationData = [];
            this.getList("4");
            this.tabRefresh[key] = true;
          }
        } else {
          this.tabRefresh[key] = false;
        }
      }
    },
    getList(relationType) {
      getWarningRelationshipList({
        schemeId: this.schemeId,
        packId: this.packId,
        type: relationType,
        percent: "50",
        phaseType: "8"
      }).then(res => {
        if (res.data.code == "0") {
          this.relationData = res.data.data.list;
          console.log(relationType, this.relationData, "relationType");
          if (res.data.data.tips) {
            this.dialogShow = true;
            this.tips = res.data.data.tips.split("-");
          }
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.el-tabs__content {
  margin-top: 35px !important;
}
/deep/.el-tabs__nav-wrap::after {
  background-color: transparent !important;
}
.ccui-multifunctional-table-wrapper /deep/.el-dialog {
  overflow: hidden;
  width: 50% !important;

  .el-dialog__body {
    max-height: auto !important;
    height: auto !important;
  }
}
</style>
